import { Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { AiOutlineExclamationCircle } from 'react-icons/ai'
import { useSelector } from 'react-redux'
import * as campanhaActions from '../../store/modules/backoffice/campanha/actions'
import { CustomButton, SimpleTitleCard } from 'styles/global'
import { ApplicationState } from 'store'
import { CAMPANHA } from 'store/modules/backoffice/campanha/types'
import useRedux from 'hooks/useRedux'

const ModalAtivarDesativarCampanha = () => {
  const { modalAtivarDesativar, acaoModal, codigoCampanhaDiscador } =
    useSelector<ApplicationState, CAMPANHA>((state) => state.campanha)
  const { dispatch } = useRedux()

  const handleConfirm = () => {
    if (!codigoCampanhaDiscador || !acaoModal) return

    dispatch(campanhaActions.confirmarAcaoCampanhaSaga())
  }
  const titulo =
    acaoModal === 'iniciar' ? 'Iniciar Campanha' : 'Pausar Campanha'

  const toggleModal = () => {
    campanhaActions.toggleModalAtivarDesativarDispatch(false)
  }

  const mensagem =
    acaoModal === 'iniciar'
      ? 'Deseja realmente iniciar esta campanha?'
      : 'Deseja realmente pausar esta campanha?'

  return (
    <Modal isOpen={modalAtivarDesativar}>
      <ModalHeader toggle={toggleModal}>
        <SimpleTitleCard colorIcon="F7931E">
          <AiOutlineExclamationCircle className="icon" />
          {titulo}
        </SimpleTitleCard>
      </ModalHeader>
      <ModalBody>
        <p>{mensagem}</p>
      </ModalBody>
      <ModalFooter className="d-flex justify-content-center">
        <Row className="d-flex column-gap-20">
          <CustomButton onClick={toggleModal} background="#662D91">
            Cancelar
          </CustomButton>
          <CustomButton onClick={handleConfirm}>Confirmar</CustomButton>
        </Row>
      </ModalFooter>
    </Modal>
  )
}

export default ModalAtivarDesativarCampanha
